import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment'

/**
  * @author Ministerio de cultura
  * @createdate 2024-10-14
  * Interceptor que se encarga de mostrar u ocultar el spinner durante un llamado http.
*/
@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private urlPrefix = environment.URL_BACK;
  private excludeListRoutes = [
    'codigos_unspsc/paa_all',
    'planificacion_paa/get_total_contrato'
  ];

  constructor(
    private ngxSpinnerService: NgxSpinnerService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.startsWith(this.urlPrefix) && !this.excludeRoute(request.url)) this.ngxSpinnerService.show();
    return next.handle(request).pipe(
      finalize(() => {
        setTimeout(() => {
          if (request.url.startsWith(this.urlPrefix) && !this.excludeRoute(request.url)) this.ngxSpinnerService.hide();
        }, 100);
      })
    );
  }

  /**
    * @author Ministerio de cultura
    * @createdate 2024-12-06
    * Metodo que valida si la ruta que pasa por el request esta dentro de las listas de rutas excluidas.
    * @param url URL a validar.
  */
  private excludeRoute(url: string): boolean {
    return this.excludeListRoutes.some(route => url.includes(route));
  }
}